import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSnackBar } from '@angular/material';
import { SessionStorage } from 'ngx-webstorage';
import { OrganizationalReportService } from './organizational-report.service';
import { DatePipe } from '@angular/common';
import { IMyOptions, IMyDateModel } from 'mydatepicker';
import { EmployeeList } from './organizational-report';
import { ReportHierarchyComponent } from '../organizational-report/report-hierarchy/report-hierarchy.component';

@Component({
  selector: 'app-organizational-report',
  templateUrl: './organizational-report.component.html',
  styleUrls: ['./organizational-report.component.css']
})
export class OrganizationalReportComponent implements OnInit {
  @SessionStorage() public user;
  public myDatePickerOptions: IMyOptions;
  public myDatePickerEndOptions: IMyOptions;
  public startDate: any;
  public endDate: any;
  public reportStartDate: any;
  public reportEndDate: any;
  public projectlistarr = [];
  public employee: Array<Object> = [];
  public searchOrganization: any = '';

  @ViewChild(ReportHierarchyComponent) child;

  constructor(
    private snackBar: MatSnackBar,
    public reportService: OrganizationalReportService,
    private datePipe: DatePipe
  ) {
    const date: Date = new Date();
    date.setDate(date.getDate() + 1);

    this.myDatePickerOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };

    this.myDatePickerEndOptions = {
      dateFormat: 'dd-mm-yyyy',
      markCurrentDay: true,
      openSelectorTopOfInput: false,
      showSelectorArrow: false,
      editableDateField: false,
      showClearDateBtn: true,
      inline: false,
      disableSince: {
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
      }
    };
  }

  ngOnInit() {
    this.reportService.setDateStatus({ startDate: '', endDate: '' });
    this.employeeList();
  }

  /**function to get employee list */
  employeeList() {
    this.employee = [];
    this.reportService.getEmployee(this.user.Empno).subscribe(
      (data) => {
        if (data.payload.length > 0) {
          data.payload.forEach(value => {
            this.employee.push(value);
          });
        }
      });
  }

  /**function to search employee*/
  searchEmployee() {
    this.employee = [];
    this.reportService.employeeSearch(this.user.Empno, this.searchOrganization).subscribe(
      (data) => {
        if (data.payload.length > 0) {
          data.payload.forEach(value => {
            this.employee.push(value);
          });
        }
      });
  }

  /**function to check search field*/
  checkSearchData() {
    if (!this.searchOrganization) {
      this.employeeList();
    }
  }

  /**function to search employee*/
  applySearch() {
    this.searchEmployee();
  }

  /**function to validate start and end date*/
  utilizationDatePicker() {
    const startDate = this.startDate ? this.datePipe.transform(this.startDate.jsdate, 'yyyy-MM-dd') : '';
    const endDate = this.endDate ? this.datePipe.transform(this.endDate.jsdate, 'yyyy-MM-dd') : '';
    const date = { startDate: startDate, endDate: endDate };
    this.reportService.setDateStatus(date);
    if (startDate && endDate) {
      if (this.startDate.epoc < this.endDate.epoc) {
        if (!!this.searchOrganization) {
          this.searchEmployee();
        } else {
          this.employeeList();
        }
      } else {
        this.snackBar.open('Please select the valid date range', 'OK', {
          duration: 3000
        });
      }
    }  else if (!startDate && !endDate) {
      if (!!this.searchOrganization) {
        this.searchEmployee();
      } else {
        this.employeeList();
      }
    } else if (!endDate) {
      this.snackBar.open('Please select the end date', 'OK', {
        duration: 3000
      });
    } else if (!startDate) {
      this.snackBar.open('Please select the start date', 'OK', {
        duration: 3000
      });
    }

  }

}



// WEBPACK FOOTER //
// ./src/app/rm/organizational-report/organizational-report.component.ts